<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      src="/pronto.svg"
      alt="Pronto"
      class="logo__image"
      height="54"
      width="160"
      decoding="auto"
      loading="eager"
      fetchpriority="high"
    >
  </AppLink>
</template>

<style>
@import url("~layers/components/App/Logo.css");
</style>
